import { Injectable } from '@angular/core';
import { HttpClientService } from '../../utils/http-client.module';
import { CookieClientService } from '../../utils/cookieClient';
import { EncryptService } from '../../encrypt/encrypt-util';
import { SignInInfo } from './sign-in.model';
import { APPCONFIG } from '../../config';
@Injectable()
export class SignInService {

  config = APPCONFIG;

  constructor(public httpClient: HttpClientService,
              private encUtil : EncryptService,
              private cookieClient: CookieClientService
  ) {

  }

  private tokenKey:string = 'authorization';

  signIn(signInfo :SignInInfo){
    return this.httpClient.post(this.config.ApiHost + '/signIn', {userId : signInfo.email, encPassword: this.encUtil.encMd5(signInfo.password)});
  }

  getUserInfo(){
    return this.httpClient.get(this.config.ApiHost + '/users/myInfo');
  }

  applyForgotMail(email:string){
    return this.httpClient.post(this.config.ApiHost + '/password/reset/auth', {email:email})
  }

  verifyApply(token:string, email:string){
    return this.httpClient.post(this.config.ApiHost + '/password/reset/verify/'+token , {email:email})
  }

  resetPassword(userId:string, authNo:string, newEncPassword:string){
    return this.httpClient.post(this.config.ApiHost + '/password/reset', {userId:userId,authNo:authNo, newEncPassword : this.encUtil.encMd5(newEncPassword)});
  }

  changePassword(userId:string, newEncPassword:string){
    return this.httpClient.post(this.config.ApiHost + '/password/change', {userId:userId, curEncPassword: this.encUtil.encMd5(userId), newEncPassword : this.encUtil.encMd5(newEncPassword)});
  }


}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/common/sign-in/sign-in.service.ts